import { getRequest, postRequest } from "./ApiInstence";

// Start SEO Scan
export const startSEOCheckApi = (data) =>
  postRequest("start-seo-check/", data);

// Full SEO results
export const getFullSEOResultsApi = (id) =>
  getRequest(`project/${id}/seo-results/`);

// Single SEO result (page speed, backlinks, etc.)
export const getSEOResultApi = (id, endpoint) =>
  getRequest(`project/${id}/seo/${endpoint}/`);

//added by neeraj
// Discover endpoints for a given site (expected backend route - implement server-side)
export const scanSiteEndpointsApi = (data) =>
  postRequest("tools/scan-endpoints/", data);


